import script from "./HomeB.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeB.vue?vue&type=script&setup=true&lang=js"

import "./HomeB.vue?vue&type=style&index=0&id=d8cf6196&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8cf6196"]])

export default __exports__